/**
 * COURE.HUB.DS.TransactionLog.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type UserChannelTypeEnum = 1 | 2;

export const UserChannelTypeEnum = {
    NUMBER_1: 1 as UserChannelTypeEnum,
    NUMBER_2: 2 as UserChannelTypeEnum
};